module.exports = __webpack_public_path__ + "kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTgY3KcC-wLOj.b105cf87bfe3a58447db.woff2";


//////////////////
// WEBPACK FOOTER
// /builds/maxmatthiessen/applications/advice4lifeweb/src/assets/fonts/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTgY3KcC-wLOj.woff2
// module id = ../../../../../src/assets/fonts/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTgY3KcC-wLOj.woff2
// module chunks = styles